import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";
import ThaiDatePicker from '../../Components/ThaiDatePicker';

import {NumberFormat,MobileFormat,DateThaiFormat,DateFormat,DateThai,GetRole} from '../../Utils/Function';
import moment from 'moment';
import { createRoot } from 'react-dom/client';
import {MemberInfoCard} from '../../Components/Member';
import Swal from 'sweetalert2';
import API from '../../API';
import '../../Assets/CSS/TALFC.css';

const PageTopupList =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();

    const ref = useRef();
    const _MemberInfoCard = useRef();
    const [_Date,setDate] = useState(new Date());
    const [_StaffList,setStaffList] = useState([]);
    useEffect(() => {
        (async () => {
            setValue("Date",new Date());
            _LoadStaffList();
        })();

        return ()=>{ }
    }, []);
   const _LoadStaffList = async()=>{
        setStaffList([]);
        API({method : "get",url:"/Staff/List"}).then(res=>{
                if (res.status !== 200) {
                    return;
                }
    
                if (!res.data.Status) {
                    return;
                }
                setStaffList(res.data.Data);
        }).catch(res => {
                return;
        });
    }
    const _configs = {
        "order": [[0, "desc"]],
        pageLength: 25,
        orderMulti: true
    }
    
    const _ajax  = {
        'url': '/Topup/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.UserID = getValues('UserID');
            const _D = moment(getValues('Date'));
            d.Date = _D.format("YYYY/MM/DD");
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
        </div>
    )
    const _column = [
       {data: "Created", name: "Created", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        { data: "MemberCode", name: "MemberCode", autoWidth: true },
        { data: "Name", name: "Name", autoWidth: true },
        { data: "Amount", name: "Amount", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "AfterCredit", name: "AfterCredit", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "Status", name: "Status", autoWidth: true,render(data){
            switch(data){
                case 1 : return '<label class="text-success">เติมเงิน</label>';
                case 2 : return '<label class="text-danger">ยกเลิก</label>';
                default : return '-';
            };
        } },
        { data: "ReasonName", name: "ReasonName", autoWidth: true },
        {
            data: "TransactionID", name: "TransactionID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    const _UpdateTable =()=>{
        ref.current?.load();
    }

    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
 
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>รายการยอดเติมเงิน</h3>
                            </div>
                            <div className='card-body' style={{'minHeight':'300px'}}>
                                <div className="row mt-2 mb-2 justify-content-end">
                                    <div className='col-12 col-lg-2'>
                                        <ThaiDatePicker className='form-control text-center' selected={_Date} onChange={(date) => { setDate(date);setValue('Date',date); setTimeout(()=>{ref.current.load();},200); }} selectsStart startDate={_Date} maxDate={new Date()} />
                                    </div>
                                    <div className='col-12 col-lg-3 text-end'>
                                        <div className='input-group float-end'>
                                            <select className='form-control text-center' {...register("UserID", { required: false })} defaultValue={0} onChange={(e)=>{setValue("UserID",e.target.value); setTimeout(()=>{ref.current.load();},200);}} >
                                                <option value={''} selected>ทั้งหมด</option>
                                                {_StaffList.map((v,i)=>(
                                                    <option key={i} value={v.UserID}>{v.Name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-lg-12 table-responsive">
                                        <table id="TopupTableView" className='table w-100' role='grid'>
                                            <thead>
                                                <tr>
                                                <th className="text-center textcenter">วันที่ / เวลา</th>
                                                <th className="text-center textcenter no-sort">รหัสประจำตัว</th>
                                                <th className="text-center textcenter no-sort">ชื่อ-นามสกุล</th>
                                                <th className="text-center textcenter">ยอดเงิน</th>
                                                <th className="text-center textcenter no-sortr">ยอดเงินคงเหลือ</th>
                                                <th className="text-center textcenter no-sortr">สถานะ</th>
                                                <th className="text-center textcenter no-sort">หมายเหตุ</th>
                                                <th className="text-center no-sort"></th>
                                                </tr>
                                            </thead>
                                            <DataTable TableID={"TopupTableView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MemberInfoCard ref={_MemberInfoCard} />
        </React.Fragment>
        </>
    )
}

export default React.memo(PageTopupList)
